import script from "./backhead.vue?vue&type=script&setup=true&lang=js"
export * from "./backhead.vue?vue&type=script&setup=true&lang=js"

import "./backhead.vue?vue&type=style&index=0&id=97033da8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97033da8"]])

export default __exports__